<template>
  <nav class="bottom-nav">
    <a href="https://t.me/mudratokenhome" target="_blank" class="nav-item">
      <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M3 9.75l9-7.5 9 7.5V21a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 21V9.75z"/>
      </svg>
      <span>Home</span>
    </a>

    <a href="https://t.me/mudratokenwrite" target="_blank" class="nav-item">
      <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16.862 3.487a2.25 2.25 0 013.182 3.182l-11.25 11.25-3.75.75.75-3.75 11.25-11.25z"/>
      </svg>
      <span>Write</span>
    </a>

    <a href="https://t.me/mudratokenpaper" target="_blank" class="nav-item">
      <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M4.5 3.75A.75.75 0 015.25 3h13.5a.75.75 0 01.75.75v16.5a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V3.75z"/>
      </svg>
      <span>Paper</span>
    </a>

    <a href="https://t.me/mudratokenabout" target="_blank" class="nav-item">
      <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5zM12 7.5a1.125 1.125 0 110 2.25 1.125 1.125 0 010-2.25zm.75 10.5h-1.5v-6h1.5v6z"/>
      </svg>
      <span>About</span>
    </a>
  </nav>
</template>

<style scoped>
.bottom-nav {
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  background-color: #BB6622;
  border-top: 2px solid #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.3);
}

.nav-item {
  color: #FFD700;
  text-align: center;
  text-decoration: none;
  flex: 1;
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon {
  width: 28px;
  height: 28px;
  margin-bottom: 2px;
  transition: transform 0.2s;
}

.icon:hover {
  transform: scale(1.2);
}

.nav-item span {
  display: block;
  font-size: 12px;
  color: #fff;
}
</style>